import { render, staticRenderFns } from "./drag-list.vue?vue&type=template&id=a172e6da&"
import script from "./drag-list.vue?vue&type=script&lang=js&"
export * from "./drag-list.vue?vue&type=script&lang=js&"
import style0 from "./drag-list.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports